import React, { useState } from "react";
import { FaAward, FaBuilding, FaExternalLinkAlt, FaShieldAlt, FaStar } from "react-icons/fa";
import "./Appreciations.css";

const loaCertificates = [
  { image: "/images/cert2.png", title: "Letter of Appreciation", issuer: "Riyadh Ceramics Factory", type: "Letter" },
  { image: "/images/cert3.png", title: "Letter of Appreciation", issuer: "Elkhereiji", type: "Letter" },
  { image: "/images/cert5.png", title: "Letter of Appreciation", issuer: "Nesma International Water & Energy Technology Co. Ltd.", type: "Letter" },
  { image: "/images/cert6.png", title: "Letter of Appreciation", issuer: "MOVENPICK", type: "Letter" }
];

const coaCertificates = [
  { image: "/images/cert4.png", title: "Certificate of Appreciation", issuer: "Al Nahdi", type: "Certificate" },
  { image: "/images/cert1.png", title: "Certificate of Appreciation", issuer: "Al Ziady", type: "Certificate" }
];

const Appreciations = ({ t }) => {
  const certificates = [...coaCertificates, ...loaCertificates];
  const [activeIndex, setActiveIndex] = useState(0);
  const activeCertificate = certificates[activeIndex];
  const activeType = activeCertificate.type === "Letter" ? t.letter : t.certificate;
  const activeTitle = activeCertificate.type === "Letter" ? t.letterTitle : t.certificateTitle;

  return (
    <section id="appreciations" className="appreciations">
      <div className="appreciations-inner">
        <div className="appreciations-header">
          <div>
            <p className="section-kicker">{t.kicker}</p>
            <h2 className="appreciations-title">{t.title}</h2>
          </div>
          {t.description && (
            <p className="appreciations-description">
              {t.description}
            </p>
          )}
        </div>

        <div className="trust-row">
          <div><FaShieldAlt /><span>{t.trustOne}</span></div>
          <div><FaAward /><span>{t.trustTwo}</span></div>
          <div><FaStar /><span>{t.trustThree}</span></div>
        </div>

        <div className="certificate-showcase">
          <div className="certificate-preview">
            <div className="certificate-ribbon">
              <FaAward />
              <span>{activeIndex + 1} / {certificates.length}</span>
            </div>
            <div className="certificate-frame">
              <img
                key={activeCertificate.image}
                src={activeCertificate.image}
                alt={`${activeCertificate.title} from ${activeCertificate.issuer}`}
              />
            </div>
          </div>

          <div className="certificate-details">
            <span className="certificate-pill">{activeType}</span>
            <h3>{activeTitle}</h3>
            <p>
              {t.recognitionFrom} <strong>{activeCertificate.issuer}</strong>, {t.recognitionText}
            </p>
            <div className="recognition-meta">
              <div>
                <FaBuilding />
                <span>{t.issuer}</span>
                <strong>{activeCertificate.issuer}</strong>
              </div>
              <div>
                <FaAward />
                <span>{t.recognitionType}</span>
                <strong>{activeType}</strong>
              </div>
            </div>
            <a href={activeCertificate.image} target="_blank" rel="noopener noreferrer" className="view-certificate">
              {t.viewDocument} <FaExternalLinkAlt />
            </a>
          </div>
        </div>

        <p className="gallery-hint">{t.hint}</p>
        <div className="certificate-strip" aria-label="Certificate gallery">
          {certificates.map((cert, index) => (
            <button
              className={`certificate-thumb ${index === activeIndex ? "active" : ""}`}
              key={cert.issuer}
              type="button"
              onClick={() => setActiveIndex(index)}
              aria-label={`${t.show} ${cert.type === "Letter" ? t.letterTitle : t.certificateTitle} ${t.from} ${cert.issuer}`}
            >
              <img src={cert.image} alt="" />
              <span>{cert.issuer}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Appreciations;
